import type { TranslationsBase } from './ko';

const th: TranslationsBase = {
  lang: 'th',
  langName: 'ไทย',
  flag: '🇹🇭',

  siteTitle: 'ข้อสอบ TOEFL จำลอง ฟรี — AI วิเคราะห์ | Power TOEFL 2026',
  siteDescription: 'ฝึก TOEFL iBT 2026 ฟรี 3,500+ ข้อ พร้อม AI วิเคราะห์จุดอ่อน ระบบทบทวน Ebbinghaus และตารางแปลงคะแนน — แพลตฟอร์มฝึก TOEFL ภาษาไทย',
  ogTitle: 'ข้อสอบ TOEFL จำลอง ฟรี — AI วิเคราะห์ | Power TOEFL 2026',

  navGrammar: 'ไวยากรณ์',
  navPractice: 'ฝึกแยกพาร์ท',
  navScoreChart: 'ตารางคะแนน',
  navVocabulary: 'คำศัพท์',
  navTips: 'เคล็ดลับ/กลยุทธ์',
  navFAQ: 'FAQ',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: 'การพูด',
  navWriting: 'การเขียน',
  navQuestionPool: 'คลังข้อสอบ',
  navResources: 'สื่อการเรียนรู้',

  loginButton: 'เข้าสู่ระบบ',
  wrongAnswers: 'สมุดข้อผิดพลาด',
  logout: 'ออกจากระบบ',
  loginRequired: 'สมุดข้อผิดพลาดและฟีเจอร์ต่อจากที่ค้างไว้ต้องเข้าสู่ระบบ',
  googleLogin: 'เริ่มด้วย Google เปิดฟีเจอร์พรีเมียม',

  heroBadge: 'ระบบเตรียมสอบ TOEFL ระดับพรีเมียม',
  heroTitle1: 'แพลตฟอร์มเดียว',
  heroTitle2: 'สำหรับคะแนน TOEFL สูง',
  heroDesc1: 'จากข้อสอบจำลอง 4 ทักษะรูปแบบ 2026 ถึงสมุดข้อผิดพลาด',
  heroDesc2: 'ช่วยคุณบรรลุเป้าหมายคะแนนอย่างสมบูรณ์',

  lcTitle: 'Listening',
  lcSubtitle: 'Listening — 47 ข้อ',
  lcTime: '29 นาที',
  rcTitle: 'Reading',
  rcSubtitle: 'Reading — 50 ข้อ',
  rcTime: '30 นาที',
  startTest: 'เริ่มสอบ',
  fullTestStart: 'เริ่มข้อสอบเต็ม (Reading → Listening)',
  fullTestDesc: 'ทำทั้งสองส่วนตามลำดับ',

  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  moreTools: 'เครื่องมือการเรียนเพิ่มเติม',
  practiceLabel: 'ฝึกแยกพาร์ท',
  practiceDesc: 'เรียน Reading·Listening แยกส่วน',
  scoreChartLabel: 'ตารางคะแนน',
  scoreChartDesc: 'จำนวนถูก → คะแนนแปลง',
  vocabLabel: 'คำศัพท์',
  vocabDesc: 'คำศัพท์ TOEFL ที่จำเป็น',
  tipsLabel: 'เคล็ดลับ/กลยุทธ์',
  tipsDesc: 'กลยุทธ์ Listening·Reading',
  catLabel: 'CAT แบบปรับตัว',
  catDesc: 'ปรับระดับความยากอัตโนมัติ',
  fullTestCardLabel: 'Full Test จำลอง',
  fullTestCardDesc: 'Reading + Listening จำลองจริง',

  statQuestions: 'ข้อ',
  statParts: 'พาร์ท',
  statMinutes: 'นาที',

  footerMockTest: 'ฝึกฝน',
  footerQuestionPool: 'คลังข้อสอบ',
  footerPractice: 'ฝึกแยกเซคชัน',
  footerStudy: 'การเรียนรู้',
  footerBooks: 'หนังสือแนะนำ',
  footerEtc: 'อื่นๆ',
  footerLC: 'ฝึก Listening',
  footerRC: 'ฝึก Reading',
  footerSpeaking: 'ฝึก Speaking',
  footerWriting: 'ฝึก Writing',
  footerLCStrategy: 'กลยุทธ์ Listening',
  footerRCStrategy: 'กลยุทธ์ Reading',
  footerCopyright: '© 2026 Power TOEFL. All rights reserved.',
  footerDisclaimer: 'TOEFL® เป็นเครื่องหมายการค้าจดทะเบียนของ ETS Power TOEFL ไม่ได้เป็นพันธมิตรหรือได้รับการรับรองจาก ETS เป็นแพลตฟอร์มการเรียนรู้ TOEFL อิสระ',

  faqTitle: '❓ คำถามที่พบบ่อย (FAQ)',
  faqDesc: 'ตรวจสอบคำถามที่พบบ่อยเกี่ยวกับ TOEFL และ Power TOEFL',
  faqPageTitle: 'คำนวณคะแนน TOEFL · วิธีสมัคร · อายุคะแนน — FAQ รวม 2026 | Power TOEFL',
  faqPageDesc: 'สมัครสอบ TOEFL ยังไง คะแนนหมดอายุเมื่อไหร่ แปลงคะแนนอย่างไร — รวม 30 คำถามที่คนถามมากที่สุดในหน้าเดียว',
  faqMore: 'มีคำถามเพิ่มเติมหรือไม่? เราอัปเดต FAQ อย่างต่อเนื่อง',

  scoreChartPageTitle: 'ตารางแปลงคะแนน TOEFL 2026 — ตอบถูกกี่ข้อได้กี่คะแนน? เช็คเลย | Power TOEFL',
  scoreChartPageDesc: 'เช็คคะแนน TOEFL ทันทีจากจำนวนข้อที่ถูก LC·RC แยกตาราง + แนวทางเรียนตามเป้าคะแนน ฟรี',
  scoreChartHeading: '📊 ตารางแปลงคะแนน TOEFL',
  scoreChartIntro: 'ตารางคะแนนรายส่วน 0–30 และรวม 0–120 เป็นค่าประมาณเพื่อการเรียนของ Power TOEFL บนสเกลเดิมที่ใช้เปรียบเทียบ รายงานทางการปี 2026 แสดงคะแนนรายส่วนและรวม 1–6 ทีละครึ่งคะแนนเป็นหลัก',
  scoreChartLC: 'ตาราง LC (Listening)',
  scoreChartRC: 'ตาราง RC (Reading)',
  scoreChartCorrect: 'จำนวนถูก',
  scoreChartConverted: 'คะแนนแปลง',
  scoreChartUnit: 'ข้อ',
  scoreChartPointUnit: 'คะแนน',
  scoreGuideTitle: '🎯 แนวทางตามเป้าหมายคะแนน',
  scoreGuide900: 'สูงสุด',
  scoreGuide900Desc: 'ต้องตอบถูก LC 90+ / RC 90+ เกือบคะแนนเต็ม',
  scoreGuide800: 'สูง',
  scoreGuide800Desc: 'เป้าหมาย LC 80+ / RC 80+ ภาษาอังกฤษธุรกิจขั้นสูง',
  scoreGuide700: 'ปานกลาง-สูง',
  scoreGuide700Desc: 'เพียงพอสำหรับเงื่อนไขการจ้างงานส่วนใหญ่ ต้องเรียนอย่างสม่ำเสมอ',
  scoreGuide600: 'ปานกลาง',
  scoreGuide600Desc: 'มีพื้นฐานดี แนะนำให้เน้น Reading และ Listening',
  scoreChartFaqTitle: '❓ คำถามที่พบบ่อยเกี่ยวกับคะแนน TOEFL',
  scoreChartCtaTitle: 'ตรวจสอบระดับของคุณเลย',
  scoreChartCtaDesc: 'ทดสอบฟรีรูปแบบ 2026 เพื่อดูคะแนนที่คาดว่าจะได้',

  vocabPageTitle: 'คำศัพท์ TOEFL ออกบ่อย 600 คำ — แยกหมวด พร้อมตัวอย่าง | Power TOEFL',
  vocabPageDesc: 'ธุรกิจ · HR · การตลาด · การเงิน · การผลิต · ชีวิตประจำวัน 6 หมวด 600 คำ คลิกเปิดความหมายและตัวอย่างประโยคทันที',
  vocabHeading: '📚 คำศัพท์ TOEFL ที่จำเป็น',
  vocabIntro: 'เรียนรู้คำศัพท์แยกตามหมวดหมู่ คลิกเพื่อดูความหมาย',
  vocabShowAll: 'แสดงทั้งหมด',
  vocabHideAll: 'ซ่อนทั้งหมด',
  vocabReset: 'รีเซ็ต',
  vocabClickToReveal: 'คลิกเพื่อดูความหมาย',
  vocabMotivation: 'เรียนซ้ำๆ อย่างสม่ำเสมอ คะแนน TOEFL จะเพิ่มขึ้น! 🚀',
  vocabCatNaturalScience: 'วิทยาศาสตร์ธรรมชาติ',
  vocabCatSocialScience: 'สังคมศาสตร์',
  vocabCatHumanities: 'มนุษยศาสตร์',
  vocabCatLifeScience: 'วิทยาศาสตร์ชีวภาพ',
  vocabCatTechnology: 'เทคโนโลยี/วิศวกรรม',
  vocabCatAcademicGeneral: 'วิชาการทั่วไป',
  vocabSynonyms: 'คำพ้องความหมาย',
  vocabAntonyms: 'คำตรงข้าม',
  vocabMyWords: 'คำศัพท์ของฉัน',
  vocabAddWord: 'เพิ่มคำ',
  vocabAddWordPlaceholder: 'พิมพ์คำศัพท์ภาษาอังกฤษ',
  vocabMyWordsEmpty: 'ยังไม่มีคำศัพท์ ลองเพิ่มคำด้านบน!',
  vocabDeleteWord: 'ลบ',
  vocabLookingUp: 'กำลังค้นหา...',
  vocabQuizTitle: 'แบบทดสอบคำศัพท์',
  vocabQuizDesc: 'ทดสอบคำพ้องความหมายและคำตรงข้ามที่เรียนรู้!',
  vocabQuizMode_synonym: 'คำพ้องความหมาย',
  vocabQuizMode_antonym: 'คำตรงข้าม',
  vocabQuizMode_mixed: 'แบบผสม',
  vocabQuizClose: 'ปิด',
  vocabQuizNoQuestions: 'หมวดหมู่นี้มีคำถามไม่เพียงพอ',
  vocabQuizBack: 'กลับ',
  vocabQuizResult: 'ผลลัพธ์',
  vocabQuizExcellent: 'ยอดเยี่ยม! 🎉',
  vocabQuizGood: 'ทำได้ดี! ฝึกอีกนิดจะสมบูรณ์แบบ!',
  vocabQuizKeepGoing: 'ฝึกต่อไป! 💪',
  vocabQuizRetry: 'ทำอีกครั้ง',
  vocabQuizFindSynonym: 'เลือกคำพ้องความหมายของคำนี้',
  vocabQuizFindAntonym: 'เลือกคำตรงข้ามของคำนี้',
  vocabQuizNext: 'ถัดไป',
  vocabQuizFinish: 'ดูผลลัพธ์',
  vocabQuizStart: 'เริ่มแบบทดสอบ',

  tipsLCPageTitle: 'วิธีเพิ่มคะแนน Listening TOEFL | เทคนิคฝึก LC — Power TOEFL',
  tipsLCPageDesc: 'วิธีเพิ่มคะแนน Listening TOEFL ด้วยเทคนิคฝึกจริง Conversations·Lectures กลยุทธ์อ่านล่วงหน้า หลีกเลี่ยงกับดัก',
  tipsLCHeading: '🎧 วิธีเพิ่มคะแนน Listening TOEFL',
  tipsLCIntro: 'สรุปกลยุทธ์หลักและเทคนิคฝึกจริงสำหรับ TOEFL LC Conversations·Lectures',
  tipsLCButton: 'กลยุทธ์ LC',
  tipsRCButton: 'กลยุทธ์ RC',
  tipsLCPractice: 'ฝึก LC จริง',
  tipsLCPracticeDesc: 'เรียนรู้กลยุทธ์แล้ว มาฝึกด้วยข้อสอบจำลอง',
  tipsLCStartTest: 'เริ่มข้อสอบ LC',
  tipsRCPageTitle: 'แก้ปัญหาเวลาไม่พอ Reading TOEFL | กลยุทธ์แบ่งเวลา RC — Power TOEFL',
  tipsRCPageDesc: 'วิธีแก้ปัญหาเวลาไม่พอ TOEFL Reading กลยุทธ์แบ่งเวลา เทคนิคอ่านเร็ว สแกนคีย์เวิร์ด',
  tipsRCHeading: '📖 แก้ปัญหาเวลาไม่พอ Reading TOEFL',
  tipsRCIntro: 'สรุปกลยุทธ์แบ่งเวลา RC และวิธีเอาชนะแต่ละพาร์ท',
  tipsRCPractice: 'ฝึก RC จริง',
  tipsRCPracticeDesc: 'เรียนรู้กลยุทธ์แล้ว มาฝึกด้วยข้อสอบจำลอง',
  tipsRCStartTest: 'เริ่มข้อสอบ RC',

  practicePartMeta: {
    '1': { title: 'TOEFL Reading กลยุทธ์อ่านบทความวิชาการ — 20 ข้อ | Power TOEFL', desc: 'วิธีอ่านบทความวิชาการ TOEFL Reading อย่างมีประสิทธิภาพ สแกนคีย์เวิร์ด คำถามอนุมาน และสรุป' },
    '2': { title: 'TOEFL Listening Conversations — กลยุทธ์จดบันทึก | Power TOEFL', desc: 'กลยุทธ์หลัก TOEFL Listening Conversations จับจุดประสงค์ อนุมานทัศนคติ เทคนิคจดบันทึก' },
    '3': { title: 'TOEFL Listening Lectures — กลยุทธ์ 18 ข้อ | Power TOEFL', desc: 'กลยุทธ์ TOEFL Listening Lectures จับหัวข้อ อนุมานเจตนาอาจารย์ วิเคราะห์ตัวอย่าง' },
  } as Record<string, { title: string; desc: string }>,

  practicePartContent: {
    '1': {
      intro: 'TOEFL Reading อ่านบทความวิชาการ (ประมาณ 700 คำ) ตอบคำถามหัวข้อ รายละเอียด อนุมาน คำศัพท์ และสรุป 35 นาที 2 บทความ รวม 20 ข้อ การจับประโยคหลักแต่ละย่อหน้าและสแกนคีย์เวิร์ดคือกุญแจจัดการเวลา',
      commonTypes: ['หัวข้อ/จุดประสงค์ (What is the passage mainly about?)', 'รายละเอียด (According to the passage...)', 'คำศัพท์ (The word X is closest in meaning to...)', 'อนุมาน (What can be inferred?)', 'แทรกประโยค (Insert text)', 'สรุป (Prose Summary — เลือก 3 ประเด็นหลัก)'],
      strategy: ['อ่านคำถามก่อน จำคีย์เวิร์ด 2-3 คำแล้วสแกนบทความ', 'เน้นประโยคแรกแต่ละย่อหน้า (topic sentence) — บทความวิชาการ TOEFL มักเปิดด้วยประเด็นหลัก', 'คำถามคำศัพท์ดูจากบริบท ไม่ใช่ความหมายพจนานุกรม', 'คำถามสรุปเลือกเฉพาะประเด็นหลัก ไม่ใช่รายละเอียดปลีกย่อย'],
      recommendedFor: ['ผู้เริ่มต้น TOEFL — สร้างความคุ้นเคยกับการอ่านวิชาการ', 'เป้าหมาย Reading 20+ — ต้องมีกลยุทธ์จัดสรรเวลา', 'อ่อนคำถามอนุมาน/สรุป — ฝึกเฉพาะประเภท'],
      faq: [
        { q: 'TOEFL Reading เวลาไม่พอทำอย่างไร?', a: 'แบ่งเวลา 17-18 นาทีต่อบทความ ข้อยากให้ทำเครื่องหมายข้ามก่อน เก็บเวลาอย่างน้อย 3 นาทีสำหรับคำถามสรุป' },
        { q: 'เจอคำศัพท์ไม่รู้จักในคำถามคำศัพท์?', a: 'อนุมานจากบริบท ประโยคก่อน-หลังเป็นเบาะแส ความหมายอาจต่างจากพจนานุกรม' },
        { q: 'คำถามสรุป (Prose Summary) ทำอย่างไร?', a: 'เลือก 3 ตัวเลือกที่เป็นตัวแทนประเด็นหลักแต่ละย่อหน้า ตัวเลือกที่เป็นรายละเอียดของย่อหน้าเดียวเป็นคำตอบผิด' },
      ],
    },
    '2': {
      intro: 'TOEFL Listening Conversations ฟังบทสนทนาในมหาวิทยาลัย (อาจารย์-นักศึกษา, เจ้าหน้าที่-นักศึกษา) ยาว 3-5 นาที ตอบ 5 ข้อ จับจุดประสงค์ รายละเอียด และทัศนคติผู้พูดคือหัวใจ',
      commonTypes: ['จุดประสงค์การสนทนา (Why does the student visit the professor?)', 'รายละเอียด (What does the professor say about...?)', 'ทัศนคติ/เจตนา (What is the student\'s attitude?)', 'การกระทำถัดไป (What will the student probably do next?)'],
      strategy: ['จับจุดประสงค์ทันทีจากช่วงเปิดการสนทนา', 'จดบันทึกข้อมูลสำคัญ (ชื่อ วันที่ เงื่อนไข)', 'สังเกตน้ำเสียงและอารมณ์ผู้พูด — เบาะแสหลักของคำถามทัศนคติ', 'เน้นฟังบทสรุปและการกระทำถัดไปตอนจบ'],
      recommendedFor: ['TOEFL Listening ต่ำกว่า 15 — เริ่มจากบทสนทนาสั้น', 'อยากเริ่มจากประเภทง่ายกว่า Lectures', 'ต้องฝึกเทคนิคจดบันทึก'],
      faq: [
        { q: 'Conversations ต้องจดบันทึกไหม?', a: 'ต้อง TOEFL แสดงคำถามหลังฟังจบ ถ้าไม่จดจะพลาดรายละเอียด ใช้ตัวย่อและสัญลักษณ์จดเร็วๆ' },
        { q: 'จับทัศนคติผู้พูดอย่างไร?', a: 'น้ำเสียง (มั่นใจ/ไม่แน่ใจ) การแสดงอารมณ์ ("I\'m not sure about that", "That sounds great") และการย้ำซ้ำเป็นเบาะแสหลัก' },
      ],
    },
    '3': {
      intro: 'TOEFL Listening Lectures ฟังบรรยายมหาวิทยาลัย (5-7 นาที) ตอบ 6 ข้อ ครอบคลุมชีววิทยา ประวัติศาสตร์ ศิลปะ ธรณีวิทยา จับหัวข้อ อนุมานเจตนาอาจารย์ วิเคราะห์จุดประสงค์ตัวอย่างคือหัวใจ',
      commonTypes: ['หัวข้อบรรยาย (What is the lecture mainly about?)', 'เจตนาอาจารย์ (Why does the professor mention X?)', 'รายละเอียด (According to the professor...)', 'อนุมาน (What does the professor imply?)', 'โครงสร้างบรรยาย (How does the professor organize the lecture?)'],
      strategy: ['1-2 นาทีแรกจับหัวข้อและจุดประสงค์ — ประเภทคำถามพื้นฐานที่สุด', 'คิดเสมอว่าทำไมอาจารย์ยกตัวอย่าง — หัวใจของ "Why does the professor mention X?"', 'คำเชื่อม (Now, let\'s move on to...) บ่งบอกหัวข้อย่อยใหม่', 'อนุมานการเหน็บ อารมณ์ขัน คำถามชวนคิดของอาจารย์'],
      recommendedFor: ['เป้าหมาย TOEFL Listening 20+ — Lectures คือตัวชี้ขาดคะแนน', 'ฟังบรรยายวิชาการลำบาก', 'อยากจัดระบบจดบันทึก'],
      faq: [
        { q: '"Why does the professor mention X?" ทำอย่างไร?', a: 'อาจารย์ยกตัวอย่าง/เปรียบเทียบ/ทดลอง มักเพื่อเสริมหรือเปรียบเทียบแนวคิดที่อธิบายก่อนหน้า ดูบริบทก่อนจุดที่กล่าวถึง' },
        { q: 'Lectures ไม่มีความรู้พื้นฐานจะเสียเปรียบไหม?', a: 'ไม่ TOEFL ให้ข้อมูลทั้งหมดที่จำเป็นในบรรยาย ความรู้พื้นฐานช่วยได้แต่เนื้อหาบรรยายเพียงพอที่จะตอบทุกข้อ' },
      ],
    },
  } as Record<string, { intro: string; commonTypes: string[]; strategy: string[]; recommendedFor: string[]; faq: { q: string; a: string }[] }>,

  practiceRelatedLinks: '📌 เนื้อหาเรียนรู้ที่เกี่ยวข้อง',
  practiceOtherParts: 'พิชิตพาร์ทอื่น',
  practiceMockTestCTA: 'ฝึกด้วยข้อสอบจำลอง',
  practiceTipsLink: 'ดูกลยุทธ์แต่ละพาร์ท',
  practiceGrammarLink: 'เรียนแกรมมาร์',

  practiceNotFound: 'ไม่พบพาร์ทนี้',
  practiceQuestionType: 'ประเภทคำถาม',
  practiceTips: '💡 เคล็ดลับ',
  practiceExamples: '📝 ตัวอย่างโจทย์',
  practiceIntro: '📋 แนะนำพาร์ท',
  practiceCommonTypes: '📊 ประเภทที่ออกบ่อย',
  practiceStrategy: '🎯 จุดโจมตี',
  practiceRecommendedFor: '👤 แนะนำสำหรับ',
  practiceFAQ: '❓ คำถามที่พบบ่อย',
  practiceCTA: 'ฝึกเลยตอนนี้',
  practiceCTADesc: 'ทำ Part {0} ในสภาพแวดล้อมเหมือนจริง',
  practiceStartTest: 'เริ่มข้อสอบ {0}',
  practiceQuestions: 'ข้อ',
  practicePartSelect: 'เลือกพาร์ท',

  roundsTitle: 'ชุดข้อสอบจำลอง',
  roundLabel: 'TOEFL จำลอง',
  roundUnit: 'ครั้ง',
  comingSoon: 'เร็วๆ นี้',
  testPrevious: 'ก่อนหน้า',
  testNext: 'ถัดไป',
  testQuestion: 'ข้อ',
  testQuestionPrompt: 'อ่านคำถามแล้วเลือกคำตอบที่ถูกต้อง',
  testMarkAnswer: 'กรุณาเลือกหมายเลขคำตอบที่ถูกต้อง',
  testSelect: 'เลือก',
  testShowAnswer: 'ดูเฉลยและคำอธิบาย',
  testCorrect: 'ถูกต้อง!',
  testIncorrect: 'ไม่ถูกต้อง',
  testLoginPrompt: 'ต้องเข้าสู่ระบบเพื่อใช้สมุดข้อผิดพลาดและทำต่อ',
  testGoogleLogin: 'เข้าสู่ระบบด้วย Google',
  roundSelect: 'เลือกชุดข้อสอบอื่น',
  testAnswered: 'ตอบแล้ว',
  testSubmit: 'ส่งข้อสอบ',
  testSubmitTitle: 'ส่งข้อสอบ {0} หรือไม่?',
  testSubmitDesc: 'ตอบแล้ว {1} จาก {0} ข้อ',
  testUnanswered: 'ยังไม่ตอบ {0} ข้อ',
  testCannotUndo: 'ไม่สามารถยกเลิกได้',
  testContinue: 'ทำต่อ',
  testSubmitBtn: 'ส่ง',

  resultsTitle: 'ผลสอบ {0}',
  resultsTimeUsed: 'เวลาที่ใช้: {0} นาที {1} วินาที',
  resultsEstimatedScore: 'คะแนนโดยประมาณ (เต็ม 495)',
  resultsCorrect: 'ถูก',
  resultsIncorrect: 'ผิด',
  resultsAccuracy: 'อัตราถูก',
  resultsReview: 'ตรวจคำตอบ',
  resultsYourAnswer: 'คำตอบของคุณ: {0}',
  resultsCorrectAnswer: 'คำตอบถูก: {0}',
  resultsNoAnswer: 'ไม่ตอบ',
  resultsHome: 'หน้าหลัก',
  resultsWrongNotes: 'สมุดข้อผิดพลาด',
  resultsRetry: 'ทำใหม่',
  resultsShare: 'แชร์ผลสอบ',
  resultsShareText: 'คะแนน TOEFL {0} ของฉัน: {1} คะแนน! ({2}/{3} ข้อถูก, {4}%) ทดสอบฟรีที่ Power TOEFL!',
  resultsShareCopied: 'คัดลอกไปยังคลิปบอร์ดแล้ว!',
  resultsNoResults: 'ไม่พบผลสอบ',
  resultsGoHome: 'กลับหน้าหลัก',
  resultsSaved: 'บันทึกข้อผิดพลาด {0} ข้อแล้ว',

  wrongAnswersTitle: 'สมุดข้อผิดพลาด',
  wrongAnswersSaved: 'คำถามที่บันทึก',
  wrongAnswersHome: 'หน้าหลัก',
  wrongAnswersPracticeAll: 'ฝึกทั้งหมด',
  wrongAnswersAll: 'ทั้งหมด',
  wrongAnswersNoItems: 'ยังไม่มีข้อผิดพลาด ทำข้อสอบก่อน!',
  wrongAnswersYourAnswer: 'คำตอบของคุณ: {0}',
  wrongAnswersCorrectIs: 'คำตอบถูก: {0}',
  wrongAnswersReviewed: 'ทบทวนแล้ว',
  wrongAnswersRemoved: 'ลบออกจากสมุดข้อผิดพลาดแล้ว',
  wrongAnswersPracticeMode: 'โหมดฝึก',
  wrongAnswersCorrectMsg: 'ถูกต้อง!',
  wrongAnswersIncorrectMsg: 'ผิด คำตอบถูก: {0}',
  wrongAnswersNextQuestion: 'ข้อถัดไป',
  wrongAnswersFinish: 'จบการฝึก',
  wrongAnswersExitPractice: 'ออกจากการฝึก',
  wrongAnswersPracticeComplete: 'ฝึกเสร็จแล้ว!',
  wrongAnswersNoPractice: 'ไม่มีข้อผิดพลาดให้ฝึก',
  wrongAnswersLimitNotice: 'แสดงเฉพาะ 500 ข้อผิดล่าสุด',

  privacyPageTitle: 'นโยบายความเป็นส่วนตัว — Power TOEFL',
  privacyPageDesc: 'นโยบายความเป็นส่วนตัวของ Power TOEFL',
  privacyHeading: 'นโยบายความเป็นส่วนตัว',
  privacyLastUpdated: 'อัปเดตล่าสุด: 29 มีนาคม 2026',
  privacyS1Title: '1. ข้อมูลส่วนบุคคลที่เก็บรวบรวม',
  privacyS1Body: 'Power TOEFL เก็บรวบรวมอีเมล ชื่อ และรูปโปรไฟล์เมื่อเข้าสู่ระบบด้วย Google เมื่อชำระเงิน ข้อมูลจะถูกประมวลผลผ่านบริการชำระเงิน (Dodo Payments/PayPal) เราไม่เก็บข้อมูลบัตรเครดิตโดยตรง',
  privacyS2Title: '2. วัตถุประสงค์การใช้',
  privacyS2Body: 'ข้อมูลใช้เพื่อบันทึกข้อผิดพลาด จัดการความก้าวหน้า จัดการการสมัครสมาชิก สนับสนุนลูกค้า และปรับปรุงบริการ',
  privacyS3Title: '3. การเก็บรักษาและทำลายข้อมูล',
  privacyS3Body: 'เมื่อลบบัญชี ข้อมูลส่วนบุคคลจะถูกลบทันที บันทึกการชำระเงินจะถูกเก็บรักษาสูงสุด 5 ปีตามกฎหมายภาษี',
  privacyS4Title: '4. การแบ่งปันกับบุคคลที่สาม',
  privacyS4Body: 'เราแบ่งปันข้อมูลขั้นต่ำ (อีเมล) กับ Dodo Payments หรือ PayPal เพื่อประมวลผลการชำระเงินเท่านั้น ไม่แบ่งปันข้อมูลอื่นกับบุคคลที่สาม เว้นแต่กฎหมายกำหนด',
  privacyS5Title: '5. คุกกี้และโฆษณา',
  privacyS5Body: 'เว็บไซต์นี้แสดงโฆษณาผ่าน Google AdSense และใช้คุกกี้เพื่อจุดประสงค์ดังกล่าว คุณสามารถจัดการคุกกี้ได้ในการตั้งค่าเบราว์เซอร์',
  privacyS6Title: '6. การถ่ายโอนข้อมูลระหว่างประเทศ',
  privacyS6Body: 'บริการใช้เซิร์ฟเวอร์ต่างประเทศ ข้อมูลอาจถูกถ่ายโอนระหว่างประเทศเพื่อประมวลผลการชำระเงิน เราใช้มาตรการรักษาความปลอดภัยที่เหมาะสม',
  privacyS7Title: '7. สิทธิ์ของผู้ใช้',
  privacyS7Body: 'ผู้ใช้สามารถขอดู แก้ไข หรือลบข้อมูลส่วนบุคคลได้ตลอดเวลา ผู้อยู่อาศัยใน EU/EEA ได้รับสิทธิ์เพิ่มเติมภายใต้ GDPR',
  privacyS8Title: '8. ติดต่อเรา',
  privacyS8Body: 'สำหรับคำถามเกี่ยวกับข้อมูลส่วนบุคคล กรุณาส่งอีเมลไปที่ skdaks0731@gmail.com',

  termsPageTitle: 'ข้อกำหนดการใช้งาน — Power TOEFL',
  termsPageDesc: 'ข้อกำหนดการใช้งานของ Power TOEFL',
  termsHeading: 'ข้อกำหนดการใช้งาน',
  termsLastUpdated: 'อัปเดตล่าสุด: 29 มีนาคม 2026',
  termsS1Title: '1. ภาพรวมบริการ',
  termsS1Body: 'Power TOEFL เป็นแพลตฟอร์มเรียนรู้ออนไลน์สำหรับเตรียมสอบ TOEFL ดำเนินการโดย ddookddak (ชื่อธุรกิจตามกฎหมายที่จดทะเบียนของเรา) มีฟีเจอร์ฟรีและสมัครสมาชิก Premium (Pro/Lifetime) แบบเสียเงิน',
  termsS2Title: '2. เงื่อนไขการใช้งาน',
  termsS2Body: 'บริการนี้เปิดให้ทุกคนที่มีอายุ 14 ปีขึ้นไป ฟีเจอร์บางอย่างต้องเข้าสู่ระบบด้วย Google ฟีเจอร์ premium ต้องสมัครสมาชิกแบบเสียเงิน',
  termsS3Title: '3. ทรัพย์สินทางปัญญา',
  termsS3Body: 'เนื้อหาเว็บไซต์เป็นของ Power TOEFL TOEFL เป็นเครื่องหมายการค้าจดทะเบียนของ ETS เว็บไซต์นี้ไม่เกี่ยวข้องกับ ETS',
  termsS4Title: '4. บริการแบบเสียเงินและการชำระเงิน',
  termsS4Body: 'สมัครสมาชิก Premium ดำเนินการผ่านบริการชำระเงินบุคคลที่สาม (Dodo Payments/PayPal) ค่าธรรมเนียมจะถูกเรียกเก็บอัตโนมัติหรือครั้งเดียวตามแผน ราคาอาจรวม VAT ดูนโยบายการคืนเงินแยกต่างหาก',
  termsS5Title: '5. ข้อจำกัดความรับผิดชอบ',
  termsS5Body: 'คะแนนสอบจำลองและสื่อการเรียนมีไว้เพื่อการอ้างอิงเท่านั้น ไม่รับประกันผลสอบ TOEFL จริง',
  termsS6Title: '6. ข้อห้าม',
  termsS6Body: 'ห้ามทำซ้ำหรือแจกจ่ายข้อสอบโดยไม่ได้รับอนุญาต ห้ามสร้างภาระมากเกินไปต่อระบบ ห้ามแชร์บัญชี และห้ามกิจกรรมที่ผิดกฎหมาย',
  termsS7Title: '7. การเปลี่ยนแปลงและการหยุดให้บริการ',
  termsS7Body: 'ผู้ดำเนินการอาจเปลี่ยนแปลงหรือหยุดให้บริการโดยไม่แจ้งล่วงหน้า',
  termsS8Title: '8. การยกเลิกสมัครสมาชิก',
  termsS8Body: 'สมัครสมาชิกแบบเสียเงินสามารถยกเลิกได้ตลอดเวลา หลังยกเลิก ยังใช้ฟีเจอร์ premium ได้จนสิ้นสุดรอบการชำระเงิน',
  termsS9Title: '9. การเปลี่ยนแปลงข้อกำหนด',
  termsS9Body: 'ข้อกำหนดอาจเปลี่ยนแปลงได้ หากยังคงใช้บริการหลังการเปลี่ยนแปลง ถือว่ายอมรับข้อกำหนดใหม่',

  refundPageTitle: 'นโยบายการคืนเงิน — Power TOEFL',
  refundPageDesc: 'นโยบายการคืนเงินสมาชิก Premium ของ Power TOEFL',
  refundHeading: 'นโยบายการคืนเงิน',
  refundLastUpdated: 'อัปเดตล่าสุด: 15 เมษายน 2026',
  refundS1Title: '1. หลักการคืนเงิน',
  refundS1Body: 'เนื่องจากเป็นสินค้าดิจิทัล โดยหลักการแล้วไม่สามารถคืนเงินได้',
  refundS2Title: '2. กรณีคืนเงินแบบข้อยกเว้น',
  refundS2Body: 'อย่างไรก็ตาม อาจคืนเงินเป็นกรณีพิเศษเมื่อกฎหมายกำหนด เกิดการชำระเงินซ้ำ ไม่ได้รับบริการ หรือเกิดปัญหาทางเทคนิคร้ายแรง',
  refundS3Title: '3. วิธีติดต่อ',
  refundS3Body: 'หากมีคำถามเรื่องการคืนเงิน กรุณาใช้ช่องทางสนับสนุน/ข้อเสนอแนะ ติดต่อ: skdaks0731@gmail.com',
  refundS4Title: '4. การยกเลิกการสมัครสมาชิก',
  refundS4Body: 'คุณสามารถยกเลิกสมาชิกแบบชำระเงินได้ทุกเมื่อ หลังยกเลิกยังใช้งานได้จนจบรอบบิลปัจจุบัน และจะไม่มีการเรียกเก็บเพิ่ม',
  refundS5Title: '',
  refundS5Body: '',
  refundS6Title: '',
  refundS6Body: '',

  footerPrivacy: 'นโยบายความเป็นส่วนตัว',
  footerTerms: 'ข้อกำหนดการใช้งาน',
  footerRefund: 'นโยบายการคืนเงิน',
  footerAbout: 'เกี่ยวกับเรา',
  footerGuide: 'คู่มือการเรียน',
  guideLabel: 'คู่มือการเรียน',
  guideDesc: 'เทคนิคตามทักษะ กลยุทธ์ตามคะแนน เปรียบเทียบสอบ',

  aboutPageTitle: 'ข้อสอบ TOEFL จำลองฟรี + AI วิเคราะห์จุดอ่อน — Power TOEFL คืออะไร',
  aboutPageDesc: 'ข้อสอบจำลอง 4 ทักษะรูปแบบ 2026 วิเคราะห์จุดอ่อนด้วย AI ทบทวนข้อผิดอัตโนมัติ ฟรีทั้งหมด',
  aboutHeading: 'Power TOEFL — แพลตฟอร์มข้อสอบ TOEFL จำลอง',
  aboutS1Title: 'Power TOEFL คืออะไร?',
  aboutS1Body: 'Power TOEFL เป็นแพลตฟอร์มข้อสอบจำลองออนไลน์ฟรีสำหรับผู้เรียนที่เตรียมสอบ TOEFL มีข้อสอบ 4 ทักษะรูปแบบ 2026 การสร้างข้อสอบด้วย AI สมุดข้อผิดพลาด และเครื่องมืออื่น ๆ',
  aboutS2Title: 'เหมาะกับใคร?',
  aboutS2Body: 'นักศึกษาที่เริ่มเตรียมสอบ TOEFL พนักงานที่ต้องการคะแนนเป้าหมาย ผู้ที่เตรียมทำงานต่างประเทศ และทุกคนที่เรียน TOEFL ด้วยตนเอง',
  aboutS3Title: 'ฟีเจอร์หลัก',
  aboutFeature1: 'ข้อสอบจำลอง Reading·Listening·Speaking·Writing รูปแบบ 2026 (หลายชุด)',
  aboutFeature2: 'ฝึกเฉพาะ Reading·Listening·Speaking·Writing',
  aboutFeature3: 'สร้างข้อสอบตามระดับความยากด้วย AI และวิเคราะห์จุดอ่อน',
  aboutFeature4: 'บันทึกข้อผิดพลาดอัตโนมัติ + ทบทวนแบบ Ebbinghaus',
  aboutFeature5: 'ตารางแปลงคะแนนและคำศัพท์ TOEFL',
  aboutS4Title: 'ฟรี vs พรีเมียม',
  aboutS4Body: 'ใช้ข้อสอบจำลอง ฝึกแยกพาร์ท ตารางคะแนนได้ฟรี พรีเมียม (Pro) สร้างข้อสอบ AI ไม่จำกัด ไม่มีโฆษณา ใช้ข้อสอบทุกชุด',
  aboutS5Title: 'ทำไมทักษะถึงพัฒนาขึ้น?',
  aboutS5Body: 'ทบทวนอัจฉริยะตามเส้นโค้งการลืมของ Ebbinghaus วิเคราะห์จุดอ่อนแต่ละส่วนด้วย AI สภาพแวดล้อมสอบจำลองรูปแบบ 2026',
  aboutS6Title: 'ความสัมพันธ์กับ ETS',
  aboutS6Body: 'Power TOEFL ไม่ได้เป็นพันธมิตรหรือได้รับการรับรองจาก ETS TOEFL® เป็นเครื่องหมายการค้าจดทะเบียนของ ETS เว็บไซต์นี้ดำเนินการอย่างอิสระ',
  aboutS7Title: 'ติดต่อเรา',
  aboutS7Body: 'สำหรับคำถามเกี่ยวกับบริการ กรุณาส่งอีเมลไปที่ skdaks0731@gmail.com',
  aboutCtaHeading: 'เริ่มเลยตอนนี้',
  aboutCtaDesc: 'ทำข้อสอบจำลองฟรีได้เลย',
  aboutCtaStart: 'เริ่มแบบทดสอบจำลอง',
  aboutCtaPricing: 'ดูแพ็กเกจพรีเมียม',

  resumeTest: 'ทำต่อ',
  resumeDesc: '{0} ครั้งที่ {1} — {2}/{3} ข้อ',
  progressLabel: 'ความก้าวหน้า',
  timerLabel: 'เวลาที่เหลือ',
  timeUp: 'หมดเวลา!',
  navHome: 'หน้าแรก',
  navSettings: 'เคล็ดลับ',

  grammarSectionTitle: 'หนังสือไวยากรณ์อังกฤษ',
  grammarSectionDesc: 'ไวยากรณ์ที่จำเป็นสำหรับ TOEFL',
  grammarViewAll: 'ดูทั้งหมด',
  grammarChapter: 'บทที่',

  aiPracticeTitle: 'AI สร้างข้อสอบ TOEFL ไม่จำกัด — เลือกพาร์ท+ระดับ ออกข้อสอบทันที | Power TOEFL',
  aiPracticeDesc: 'เลือกพาร์ทและระดับความยาก AI สร้างข้อสอบ TOEFL พร้อมเฉลยทันที ฝึกทำฟรีทุกวันด้วยข้อสอบใหม่',
  aiPracticeH1: '✨ ฝึกข้อสอบ TOEFL จาก AI',
  aiPracticeSub: 'AI สร้างข้อสอบ TOEFL ตามระดับความยากแบบเรียลไทม์',
  aiPartLabel: 'พาร์ท',
  aiDiffLabel: 'ระดับความยาก',
  aiBeginner: 'เริ่มต้น (1.0–2.5)',
  aiIntermediate: 'กลาง (3.0–4.5)',
  aiAdvanced: 'สูง (5.0–6.0)',
  aiGenerate: 'สร้างข้อสอบ',
  aiGenerating: 'กำลังสร้าง...',
  aiRemainingToday: 'เหลือ {0} ครั้งเดือนนี้',
  aiLimitReached: 'ใช้ credit AI ครบแล้วเดือนนี้',
  aiLimitUpgrade: 'ซื้อ credit เพิ่มหรืออัปเกรดแพ็กเกจ!',
  aiUpgrade: 'อัปเกรด',
  aiListenPrompt: '🔊 ข้อสอบ LC ควรฟังเสียงขณะทำ',
  aiPlayAudio: 'เล่นเสียง',
  aiStopAudio: 'หยุด',
  aiCorrect: '✅ ถูกต้อง!',
  aiWrong: '❌ ผิด',
  aiCorrectAnswer: 'คำตอบ: {0}',
  aiPrev: 'ก่อนหน้า',
  aiNext: 'ถัดไป',
  aiNewQuestions: 'ข้อสอบใหม่',
  aiEmptyTitle: 'สร้างข้อสอบด้วย AI',
  aiEmptyDesc: 'เลือกพาร์ทและระดับความยาก แล้วกด "สร้างข้อสอบ"',
  aiLoadingMain: 'AI กำลังสร้างและตรวจสอบข้อสอบ...',
  aiLoadingSub: 'ใช้เวลาประมาณ 10-20 วินาที',

  statsTitle: 'สถิติการเรียน TOEFL — Power TOEFL',
  statsDesc: 'ดูสถิติการเรียน TOEFL เปอร์เซ็นต์ถูก สมุดข้อผิดพลาด และความก้าวหน้า',
  statsH1: '📊 สถิติการเรียน',
  statsLoginPrompt: 'เข้าสู่ระบบเพื่อดูสถิติการเรียน',
  statsTotalQuizzes: 'แบบทดสอบทั้งหมด',
  statsTotalQuestions: 'ข้อทั้งหมด',
  statsAccuracy: 'เปอร์เซ็นต์ถูก',
  statsLast7Days: '7 วันล่าสุด',
  statsWrongSummary: 'สรุปข้อผิดพลาด',
  statsViewAll: 'ดูทั้งหมด',
  statsTotalWrong: 'ผิดทั้งหมด',
  statsReviewed: 'ทบทวนแล้ว',
  statsPending: 'ยังไม่ทบทวน',
  statsTopicAccuracy: 'เปอร์เซ็นต์ถูกตามหัวข้อ',
  statsAttempts: '{0} ครั้ง',
  statsEmpty: 'ยังไม่มีประวัติการเรียน ลองทำแบบทดสอบไวยากรณ์!',
  statsStartGrammar: 'เริ่มเรียนไวยากรณ์',

  pricingTitle: 'ฟรีไม่พอแล้ว? — Power TOEFL Pro เปรียบเทียบแพ็กเกจ (฿349/เดือน) | 2026',
  pricingDesc: 'ฟรีฝึกทำรายวัน vs Pro AI ไม่จำกัด · ไม่มีโฆษณา · ปลดล็อกทุกชุด',

  testLCTitle: 'ข้อสอบจำลอง TOEFL Reading ฟรี — Academic passages | 2026',
  testLCDesc: 'ทำข้อสอบจำลอง TOEFL Reading รูปแบบ 2026 ฟรี Academic passages สมุดข้อผิดพลาดบันทึกอัตโนมัติ',
  testRCTitle: 'ข้อสอบจำลอง TOEFL Listening ฟรี — Conversations & Lectures | 2026',
  testRCDesc: 'ทำข้อสอบจำลอง TOEFL Listening รูปแบบ 2026 ฟรี Conversations และ Lectures พร้อม AI อธิบาย',

  reviewTitle: 'ทบทวนวันนี้',
  reviewDesc: 'ระบบทบทวนอัจฉริยะตามเส้นโค้งการลืมของ Ebbinghaus',
  reviewSubtitle: 'ทบทวนในเวลาที่เหมาะสมตามเส้นโค้งการลืม',
  reviewRemaining: 'ที่ต้องทบทวน',
  reviewProgress: 'ความก้าวหน้าการทบทวน',
  reviewCompleted: '🎉 ทบทวนเสร็จแล้ววันนี้!',
  reviewCompletedDesc: 'ทบทวนแล้ว {0} ข้อ',
  reviewEmpty: 'ไม่มีข้อที่ต้องทบทวนวันนี้',
  reviewEmptyDesc: 'ทบทวนครบแล้วหรือยังไม่มีข้อผิดพลาด',
  reviewStage: 'ขั้นที่ {0}',
  reviewNextInterval: 'ทุก {0} วัน',
  reviewCorrect: 'ถูกต้อง! ไปขั้นถัดไป',
  reviewWrong: 'ผิด กลับไปขั้นที่ 1',
  reviewNextReview: 'ทบทวนครั้งถัดไป: {0} วัน',
  reviewResetMsg: 'ตอบผิด จะทบทวนอีกครั้งใน 1 วัน',
  reviewNext: 'ข้อถัดไป',
  reviewFinish: 'เสร็จ',
  reviewHowItWorks: 'หลักการทบทวน Ebbinghaus',
  reviewDaysLater: '{0} วัน',
  reviewExplanation: 'ข้อผิดพลาดจะถูกทบทวนในช่วง 1→3→7→14→30→60 วัน ตอบถูกไปขั้นถัดไป ตอบผิดกลับขั้น 1',
  notifTitle: 'การแจ้งเตือน',
  notifEmpty: 'ไม่มีการแจ้งเตือนใหม่',
  notifMarkAllRead: 'อ่านทั้งหมด',
  timeJustNow: 'เมื่อสักครู่',
  timeMinutes: '{0} นาทีที่แล้ว',
  timeHours: '{0} ชั่วโมงที่แล้ว',
  timeDays: '{0} วันที่แล้ว',
  scoreCardEstimated: 'คะแนนโดยประมาณ',
  scoreCardCorrect: 'ถูก',
  scoreCardIncorrect: 'ผิด',
  scoreCardAccuracy: 'ความแม่นยำ',
  pushTitle: 'รับการแจ้งเตือนการเรียน',
  pushDesc: 'แจ้งเตือนเวลาทบทวนและสถิติการเรียนต่อเนื่อง',
  pushEnable: 'เปิดการแจ้งเตือน',
  navReview: 'ทบทวน',
  navStats: 'สถิติ',
  navPremium: 'พรีเมียม',
  navSubscription: 'จัดการแพ็คเกจ',
  roundDetailHeading: 'ข้อสอบจำลอง TOEFL',
  roundDetailOtherRounds: 'ดูชุดอื่น',
  roundSuffix: '',
  footer7DayPlan: 'แผน 7 วัน',
  footerTrapPatterns: 'กับดักข้อสอบ',
  pwaAddToHome: '📱 เพิ่มในหน้าจอหลัก',
  pwaAddToHomeDesc: 'เปิดได้ทันทีเหมือนแอป! เรียนออฟไลน์ได้',
  pwaInstall: 'ติดตั้ง',
  pwaIOSGuide: 'แชร์ → เพิ่มในหน้าจอหลัก',
  aiQuizTitle: '🤖 แบบฝึกหัด AI',
  aiQuizDesc: 'คำถาม TOEFL Grammar สร้างโดย AI',
  aiQuizGenerateDesc: 'AI สร้างคำถามสไตล์ TOEFL Grammar จำนวน 5 ข้อแบบเรียลไทม์',
  aiQuizGenerate: 'สร้างคำถาม AI',
  aiQuizGenerating: '🤖 AI กำลังสร้างคำถาม...',
  aiQuizGeneratingTime: 'ใช้เวลาประมาณ 5-10 วินาที',
  aiQuizNew: 'คำถามใหม่',
  aiQuizStats: 'สถิติสะสม:',
  aiQuizTimes: 'ครั้ง',
  aiQuizCheckAnswers: 'ตรวจคำตอบ',
  aiQuizPerfect: '🎉 ถูกทุกข้อ!',
  aiQuizCorrectCount: 'ถูก',
  aiQuizSaving: 'กำลังบันทึก...',
  aiQuizTryNew: 'ลองคำถามใหม่',
  aiQuizError: 'สร้างคำถาม AI ไม่สำเร็จ กรุณาลองใหม่',
  tipsDetailStrategy: 'กลยุทธ์เพิ่มเติม',
  tips7DayTitle: '🗓️ แผนเรียน 7 วันก่อนสอบ',
  tips7DayDesc: 'เพิ่มคะแนนด้วยแผนสุดท้าย',
  tipsTrapTitle: '⚠️ รวมกับดักข้อสอบ',
  tipsTrapDesc: 'รู้ทัน 5 กับดักที่พบบ่อย',
  pricingSaveBadge: 'ลด 30%',
  pricingPerMonth: 'เดือน',
  pricingSSL: 'ชำระเงินปลอดภัย',
  pricingCurrentPlan: 'แผนปัจจุบัน',
  pricingFaqQ1: 'ฟรีกับ Pro ต่างกันอย่างไร?',
  pricingFaqA1: 'แผนฟรีมีข้อสอบ Reading·Listening พื้นฐานและ AI 1 ครั้ง/วัน Pro มี AI ไม่จำกัด, AI ตรวจ Speaking·Writing, วิเคราะห์ 4 ทักษะ และไม่มีโฆษณา',
  pricingFaqQ2: 'ขอคืนเงินได้ไหม?',
  pricingFaqA2: 'เนื่องจากเป็นสินค้าดิจิทัล โดยหลักการแล้วไม่สามารถคืนเงินได้ อย่างไรก็ตาม อาจคืนเงินเป็นกรณีพิเศษเมื่อกฎหมายกำหนด เกิดการชำระเงินซ้ำ ไม่ได้รับบริการ หรือเกิดปัญหาทางเทคนิคร้ายแรง',
  pricingFaqQ3: 'ยกเลิกสมาชิกอย่างไร?',
  pricingFaqA3: 'คุณสามารถยกเลิกได้ทุกเมื่อที่หน้าสมาชิกของฉัน หลังยกเลิกยังใช้ได้จนหมดระยะเวลา',
  pricingFaqQ4: 'Lifetime กับ Pro รายปีต่างกันอย่างไร?',
  pricingFaqA4: 'Lifetime จ่ายครั้งเดียวใช้ตลอดชีพ Pro รายปีต้องต่ออายุทุกปี',
  proBadgeLabel: 'Pro',
  pricingCard: 'บัตรเครดิต',
  pricingPaymentSuccess: 'สมัคร Premium สำเร็จ!',
  pricingPaymentCancelled: 'การชำระเงินถูกยกเลิก',
  pricingLoginRequired: 'ต้องเข้าสู่ระบบ',
  pricingPaymentError: 'สร้างการชำระเงินไม่สำเร็จ',
  subLoginRequired: 'ต้องเข้าสู่ระบบ',
  grammarSystematic: 'เรียนไวยากรณ์อย่างเป็นระบบ',
  grammarBookTitle: 'หนังสือไวยากรณ์ TOEFL',
  grammarBookDesc: 'เรียนไวยากรณ์ 20 หัวข้อสำคัญสำหรับ TOEFL แต่ละบทมีตัวอย่างและแบบฝึกหัด',
  grammarTestAfter: 'เรียนแล้วทดสอบทันที!',
  grammarTestAfterDesc: 'ดูว่าไวยากรณ์ที่เรียนออกสอบ TOEFL อย่างไร',
  grammarMockTest: 'Mock Test',
  grammarDoneTitle: 'เรียนไวยากรณ์เสร็จแล้ว?',
  grammarDoneDesc: 'ลองทำข้อสอบจำลองเพื่อนำสิ่งที่เรียนไปใช้ ข้อที่ผิดจะบันทึกอัตโนมัติ!',
  grammarStartRC: 'เริ่ม RC Mock Test',
  grammarPracticePart5: 'ฝึก Grammar',
  grammarCourseName: 'TOEFL Grammar Complete Guide',
  grammarBreadcrumb: 'หนังสือไวยากรณ์',
  grammarHome: 'หน้าแรก',
  grammarExamples: 'ตัวอย่างจริง',
  grammarTestKnowledge: '📝 ทดสอบความรู้',
  grammarTestKnowledgeDesc: 'ลองทำข้อสอบจริงเกี่ยวกับไวยากรณ์ที่เรียน!',
  grammarCheckAnswers: 'ตรวจคำตอบ',
  grammarPerfect: '🎉 ถูกทุกข้อ!',
  grammarCorrectCount: 'ถูก',
  grammarMockCTA: '🔥 ทดสอบด้วยข้อสอบจำลอง!',
  grammarMockCTADesc: 'RC 100 ข้อ + สมุดข้อผิดพลาดอัตโนมัติ',
  grammarStartRCMock: 'เริ่ม RC Mock Test',
  grammarPractice5: 'ฝึก Grammar',
  grammarTestInPractice: 'ทดสอบจริง!',
  grammarTestInPracticeDesc: 'ดูว่าจุดไวยากรณ์นี้ออกสอบ TOEFL อย่างไร',
  grammarRelated: '📚 ไวยากรณ์ที่เกี่ยวข้อง',
  wrongAnswersGrammarAI: 'Grammar AI',
  streakDays: 'วัน',
  streakLabel: 'เรียนต่อเนื่อง',
  leaderboardTitle: 'อันดับการเรียน',
  leaderboardWeekly: 'รายสัปดาห์',
  leaderboardMonthly: 'รายเดือน',
  leaderboardLoading: 'กำลังโหลด...',
  loadingQuestions: 'กำลังโหลดคำถาม...',
  leaderboardEmpty: 'ยังไม่มีข้อมูล{period}นี้',
  leaderboardEmptyWeek: 'สัปดาห์',
  leaderboardEmptyMonth: 'เดือน',
  leaderboardHint: 'ทำข้อสอบแล้วจะลงทะเบียนอันดับอัตโนมัติ!',
  leaderboardRank: 'อันดับ',
  leaderboardNickname: 'ชื่อเล่น',
  leaderboardSolved: 'จำนวนข้อ',
  leaderboardAccuracy: 'อัตราถูก',
  leaderboardMe: 'ฉัน',
  leaderboardMyRank: '🏅 อันดับของฉัน: {rank}',
  tipsCoreTips: 'เคล็ดลับสำคัญ',
  tipsStrategy: 'กลยุทธ์จริง',
  tipsCTA: 'เรียนกลยุทธ์แล้ว ลงสนามจริง!',
  testScrollHint: 'เลื่อนลงเพื่อดูคำถามและตัวเลือก',
  testPart1Label: 'Academic Reading',
  testPart2Title: 'Conversations',
  testPart2Desc: 'ฟังเสียงแล้วเลือกคำตอบ',
  testPart3Label: 'Lectures',
  streak7: 'เรียนต่อเนื่อง 1 สัปดาห์!',
  streak14: 'เรียนต่อเนื่อง 2 สัปดาห์!',
  streak30: 'เก่งมาก! เรียนต่อเนื่อง 1 เดือน!',
  reviewItems: 'ข้อ',
  reviewTodayLabel: 'ทบทวนวันนี้',
  reviewGoLabel: '📚 ไปทบทวน →',

  creditBuyBtn: 'ซื้อเครดิต',
  creditBuyTitle: 'ซื้อเครดิต AI',
  creditBuyDesc: 'ซื้อเครดิตเพิ่มเติมสำหรับ AI Speaking/Writing และการฝึกฝน AI',
  creditBuyError: 'เริ่มการชำระเงินไม่สำเร็จ',
  creditBuyNote: 'ชำระผ่าน PayPal เครดิตจะถูกเพิ่มทันทีหลังชำระเงิน',
  creditUnit: 'เครดิต',

  speakingPageH1: 'ฝึก TOEFL Speaking 2026',
  speakingPageSub: '{count}+ โจทย์ Speaking ฟรี — Listen and Repeat · Interview',
  speakingPageTitle: 'ฝึก TOEFL Speaking 2026 — {count}+ โจทย์ฟรี | Power TOEFL',
  speakingPageDesc: 'โจทย์ TOEFL Speaking {count}+ ข้อ ตัวอย่างคำตอบ เกณฑ์ให้คะแนน AI feedback 2026',
  speakingAllTasks: 'ทั้งหมด',
  speakingNoPrompts: 'ยังไม่มีโจทย์ Speaking',
  speakingNoPromptsSub: 'กำลังสร้างโจทย์ กรุณากลับมาใหม่เร็วๆ นี้!',
  speakingResponseTime: 'เวลาตอบ',

  writingPageH1: 'ฝึก TOEFL Writing 2026',
  writingPageSub: '{count}+ โจทย์ Writing ฟรี — Build a Sentence · Email · Academic Discussion',
  writingPageTitle: 'ฝึก TOEFL Writing 2026 — {count}+ โจทย์ฟรี | Power TOEFL',
  writingPageDesc: 'โจทย์ TOEFL Writing {count}+ ข้อ ตัวอย่างคำตอบ เกณฑ์ให้คะแนน 2026',
  writingAllTasks: 'ทั้งหมด',
  writingNoPrompts: 'ยังไม่มีโจทย์ Writing',
  writingNoPromptsSub: 'กำลังสร้างโจทย์ กรุณากลับมาใหม่เร็วๆ นี้!',

  catPageTitle: 'TOEFL Adaptive Test (CAT) — AI ปรับระดับอัตโนมัติ | Power TOEFL',
  catPageDesc: 'ข้อสอบ TOEFL แบบปรับระดับ AI ปรับความยากอัตโนมัติตามเปอร์เซ็นต์ถูก',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: 'ความยากปรับอัตโนมัติตามเปอร์เซ็นต์ถูก {count} ข้อต่อรอบ',
  catNote: "ℹ️ หมายเหตุ: ข้อสอบ TOEFL iBT จริงเป็นแบบเชิงเส้น (ไม่ปรับตามผู้สอบ) Practice CAT นี้เป็นเครื่องมือฝึกที่ปรับความยากตามผลของคุณเพื่อให้ทราบระดับได้เร็ว ไม่ใช่การจำลองรูปแบบข้อสอบจริง",
  catSelectSection: 'เลือกส่วน',
  catStartBtn: 'เริ่ม Adaptive Test',
  catLoading: 'กำลังโหลดข้อถัดไป...',
  catNoMore: 'ไม่มีข้อเพิ่มเติม',
  catComplete: 'Adaptive Test เสร็จสิ้น',
  catAccuracy: 'เปอร์เซ็นต์ถูก',
  catFinalLevel: 'ระดับสุดท้าย',
  catTryAgain: 'ลองอีกครั้ง',
  catViewResults: 'ดูผลลัพธ์',
  catNext: 'ถัดไป',
  catExplanation: 'คำอธิบาย',
  catStop: 'หยุด',
  catPlayAudio: '🔊 เล่นเสียง',
  catReadingPassage: 'Reading Passage',

  scoreReadingHeader: 'Reading (0~30 คะแนน)',
  scoreListeningHeader: 'Listening (0~30 คะแนน)',
  scoreSpeakingHeader: 'Speaking (0~30 คะแนน)',
  scoreWritingHeader: 'Writing (0~30 คะแนน)',
  scoreSpeakingDesc: '4 งานให้คะแนน 0~4 แล้วแปลงเป็น 30 คะแนน',
  scoreWritingDesc: '2 งานให้คะแนน 0~5 แล้วแปลงเป็น 30 คะแนน',
  scoreSpeakingLevels: [
    ['4 คะแนน (Good)', '27~30', 'คล่องและแม่นยำ มีเหตุผล'],
    ['3 คะแนน (Fair)', '19~26', 'ค่อนข้างชัดเจน มีข้อผิดพลาดบ้าง'],
    ['2 คะแนน (Limited)', '11~18', 'สื่อสารพื้นฐานได้แต่จำกัด'],
    ['1 คะแนน (Weak)', '1~10', 'สื่อความหมายยาก'],
  ] as [string, string, string][],
  scoreWritingLevels: [
    ['5 คะแนน (Good)', '27~30', 'เรียงความมีเหตุผล เนื้อหาดี ไวยากรณ์แม่น'],
    ['4 คะแนน (Fair)', '22~26', 'โดยรวมดี มีจุดขาดบ้าง'],
    ['3 คะแนน (Limited)', '15~21', 'มีโครงสร้างพื้นฐาน แต่ขาดการพัฒนา'],
    ['2 คะแนน (Weak)', '8~14', 'ออกนอกเรื่อง โครงสร้างไม่ชัด'],
    ['1 คะแนน (Very Weak)', '1~7', 'แทบสื่อสารไม่ได้'],
  ] as [string, string, string][],
  scoreGuideDescs: [
    'ต้องการ Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+ สมัครมหาวิทยาลัยชั้นนำได้',
    'เป้าหมาย Reading 22+ / Listening 22+ ผ่านเกณฑ์มหาวิทยาลัยส่วนใหญ่',
    'ระดับอังกฤษวิชาการพื้นฐาน เข้าเรียนแบบมีเงื่อนไข ต้องเรียนเพิ่ม',
    'ระดับพื้นฐาน แนะนำเน้น Reading และ Listening',
  ],
  // --- Flashcard mode ---
  vocabFlashcardStart: "เริ่มท่องด้วยแฟลชการ์ด",
  vocabFlashcardStop: "หยุดแฟลชการ์ด",
  vocabFlashcardEmpty: "กรุณาเพิ่มคำศัพท์ก่อนเริ่มแฟลชการ์ด",
  vocabFlashcardSpeed: "ความเร็ว",
  vocabFlashcardSpeedSlow: "ช้า",
  vocabFlashcardSpeedNormal: "ปกติ",
  vocabFlashcardSpeedFast: "เร็ว",
  vocabFlashcardShuffle: "สลับ",
  vocabFlashcardPrev: "ก่อนหน้า",
  vocabFlashcardNext: "ถัดไป",
  vocabFlashcardFlip: "พลิก",
  vocabFlashcardProgress: "{current} / {total}",
};

export default th;
